/* Utils */
import { checkIsBotUA } from '@utils/ui';

const shouldNotRunCheck = () => {
  const isNotBrowser = !process.browser;
  const isBotUA = checkIsBotUA();
  return isNotBrowser || isBotUA;
};

/*
 * Wrapper methods for Gladly methods.
 * Enables us to error gracefully and format what we need.
 *
 * hideChatIconOverride: function that return a boolean
 * */
type TGladlyChat = {
  isInitialized: boolean;
  start: (options?: { callBack?: () => void; force?: boolean }) => void;
  stop: () => void;
  identify: (data: { email: string; name: string }) => void;
  open: () => void;
  logout: () => void;
  hideChat: () => void;
};

const GladlyChat: TGladlyChat = {
  isInitialized: false,

  /**
   * Lets allow for retries if the init fails
   *
   * @param {function} callBack
   * @param {boolean} force - force the initialization
   * @returns {Promise<void>}
   */
  async start({ callBack, force = false } = {}) {
    if ((window.Gladly?.getUser || this.isInitialized) && !force) return;

    try {
      GladlyChat.isInitialized = true;

      window.Gladly.init({
        appId: 'hellotech.com-test1',
        autoShowButton: true,
      })
        .then(() => {
          callBack?.();
        })
        .catch((error: Error) => {});
    } catch (error) {
      this.isInitialized = false;
    }
  },

  stop() {
    window.Gladly?.close?.();
  },

  identify({ email, name }: { email: string; name: string }) {
    if (shouldNotRunCheck() || window.Gladly?.getUser?.()) {
      return;
    }

    window.Gladly?.setUser?.({
      email,
      name: name || email,
    });
  },

  open() {
    window.Gladly?.show?.();
  },

  logout() {},

  hideChat() {
    window.Gladly?.close?.();
  },
};

const HTGladlyChat = new Proxy(GladlyChat, {
  get(target: TGladlyChat, key: keyof TGladlyChat) {
    if (shouldNotRunCheck()) return () => {};

    return target[key];
  },
});

export default HTGladlyChat;
